(() => {
  const update = anchor => {
    const href = anchor.getAttribute('href');
    if (!href) return;
    let url;
    try { url = new URL(href, document.baseURI); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol) || url.origin === location.origin) return;
    anchor.target = '_blank';
    anchor.relList.add('noopener');
  };
  const scan = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('a[href]')) update(root);
    root.querySelectorAll('a[href]').forEach(update);
  };
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
